import { render, staticRenderFns } from "./SimpleSignEDigital.vue?vue&type=template&id=2dff8094&"
import script from "./SimpleSignEDigital.vue?vue&type=script&lang=js&"
export * from "./SimpleSignEDigital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dff8094')) {
      api.createRecord('2dff8094', component.options)
    } else {
      api.reload('2dff8094', component.options)
    }
    module.hot.accept("./SimpleSignEDigital.vue?vue&type=template&id=2dff8094&", function () {
      api.rerender('2dff8094', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/simple/edigital/SimpleSignEDigital.vue"
export default component.exports